'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechdetails', {
        url: '/speechdetails',
        template: '<speechdetails></speechdetails>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechdetails/speechdetails.routes.js